import { render, staticRenderFns } from "./BasicInformationAssistance.vue?vue&type=template&id=320a310f&"
import script from "./BasicInformationAssistance.vue?vue&type=script&lang=js&"
export * from "./BasicInformationAssistance.vue?vue&type=script&lang=js&"
import style0 from "./BasicInformationAssistance.vue?vue&type=style&index=0&id=320a310f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports